import Vue from "vue";
import Router from "vue-router";
import Search from "@/views/Search.vue";
import Dashboard from "@/views/Dashboard.vue";
import Tender from "@/views/Tender.vue";
import Buyer from "@/views/Buyer.vue";
import Supplier from "@/views/Supplier.vue";
import Category from "@/views/Category.vue";
import Entities from "@/views/Entities.vue";
import Suppliers from "@/views/Suppliers.vue";
import Categories from "@/views/Categories.vue";
import StoryBoard from "@/views/StoryBoard.vue";
import OpenBoard from "@/views/OpenBoard.vue";
import SearchProfiles from "@/views/SearchProfiles.vue";
import Pipelines from "@/views/Pipelines.vue";
import Storyboards from "@/views/Storyboards.vue";
import Cluster from "@/views/Cluster.vue";
import Clusters from "@/views/Clusters.vue";
import Audits from "@/views/Audits.vue";
//import SearchProfiles from "@/views/SearchProfiles.vue";
import Industry from "@/views/Industry.vue";
import Panel from "@/views/Panel.vue";
import Panels from "@/views/Panels.vue";
import TraceyChatPage from "@/views/TraceyChatPage.vue";
import UsagePage from "@/views/UsagePage.vue";
import SharedChart from "@/views/SharedChart.vue";
import NotFound from "@/views/NotFound.vue";
import Unsubscribe from "@/views/Unsubscribe.vue";
import User from "@/views/User.vue";
//import BuyerSearch from "@/views/BuyerSearch.vue";
//import SignIn from "@/views/SignIn.vue";
//import Register from "@/views/Register.vue";
//import Confirm from "@/views/Confirm.vue";
//import ChangePass from "@/views/ChangePass.vue";
import SpendingScatter from "@/components/SpendingScatter";
import QuarterlyTrends from "@/components/QuarterlyTrends.vue";
import SpendingTree from "@/components/SpendingTree";
import SpendComparison from "@/components/SpendComparison";
import SpendingPie from "@/components/SpendingPie";
import NetworkView from "@/components/NetworkView";
import ResultsExpiryCycle from "@/components/ResultsExpiryCycle";
import ResultsLeaderboard from "@/components/ResultsLeaderboard";
import TraceyResults from "@/components/TraceyResults";
import Report from "@/components/Report";
import ResultsDashboard from "@/components/ResultsDashboard";
import ClusterAdministration from "@/views/ClusterAdministration";
import AdminPortal from "@/views/AdminPortal";
import StoryboardAdministration from "@/views/StoryboardAdministration";
import SavedSearchAdministration from "@/views/SavedSearchAdministration";
import MonitoringAdministration from "@/views/MonitoringAdministration";
//import ElineChart from "@/components/ELineChart";
import { loggedIn } from "./components/LoginManager";
import { logout } from "./components/LoginManager";
import { authGuard } from "./auth/authGuard";
//import {bus} from "./main.js"

Vue.use(Router);

function requiresAuth(to, from, next) {
  if (!loggedIn()) {
    logout();
    next("/sign-in");

    //next("/sign-in");
  } else {
    next();
  }
}

const router = new Router({
  mode: "history",

  routes: [
    {
      path: "/",
      name: "home",
      component: Dashboard,
      meta: { title: 'Dashboard' },
      beforeEnter: authGuard
      //navigation guard to ensure user is signed in
    },
    /* {
      path: "/buyer",
      name: "buyer-search",
      component: BuyerSearch,
      beforeEnter: requiresAuth
      //navigation guard to ensure user is signed in
    }, */
    {
      path: "/entities",
      name: "entities",
      component: Entities,
      meta: { title: 'Buyers Directory' },
      beforeEnter: authGuard
      //navigation guard to ensure user is signed in
    },
    {
      path: "/audits",
      name: "audits",
      component: Audits,
      meta: { title: 'Audits' },
      beforeEnter: authGuard
      //navigation guard to ensure user is signed in
    },
    {
      path: "/categories",
      name: "categories",
      component: Categories,
      meta: { title: 'Categories Directory' },
      beforeEnter: authGuard
      //navigation guard to ensure user is signed in
    },
    {
      path: "/suppliers",
      name: "suppliers",
      component: Suppliers,
      meta: { title: 'Suppliers Directory' },
      beforeEnter: authGuard
      //navigation guard to ensure user is signed in
    },
    {
      path: "/clusters",
      name: "clusters",
      component: Clusters,
      meta: { title: 'Clusters' },
      beforeEnter: authGuard
      //navigation guard to ensure user is signed in
    },
    /* {
      path: "/search_profiles",
      name: "search_profiles",
      component: SearchProfiles,
      meta: { title: 'Search Profiles' },
      beforeEnter: authGuard
      //navigation guard to ensure user is signed in
    }, */
    {
      path: "/entity/:id",
      name: "entity",
      component: Buyer,
      meta: { title: 'Public Entity Profile' },
      beforeEnter: authGuard
      //navigation guard to ensure user is signed in
    },
    {
      path: "/supplier/:id",
      name: "supplier",
      component: Supplier,
      meta: { title: 'Supplier Profile' },
      beforeEnter: authGuard
      //navigation guard to ensure user is signed in
    },
    {
      path: "/category/:id",
      name: "category",
      component: Category,
      meta: { title: 'Category Profile' },
      beforeEnter: authGuard
      //navigation guard to ensure user is signed in
    },
    {
      path: "/search",
      name: "search",
      component: Search,
      meta: { title: 'Search' },
      beforeEnter: authGuard
      //navigation guard to ensure user is signed in
    },
    {
      path: "/report/:storyboardId",
      name: "storyboard",
      component: StoryBoard,
      props: true,
      meta: { title: 'Report' },
      beforeEnter: authGuard
    },
    {
      path: "/reports",
      name: "storyboards",
      component: Storyboards,
      meta: { title: 'Reports Directory' },
      beforeEnter: authGuard
    },
    {
      path: "/search-profiles",
      name: "search-profiles",
      component: SearchProfiles,
      meta: { title: 'Search Profiles' },
      beforeEnter: authGuard
    },
    {
      path: "/pipelines",
      name: "pipelines",
      component: Pipelines,
      meta: { title: 'Pipelines' },
      beforeEnter: authGuard
    },
    {
      path: "/cluster/:clusterId",
      name: "cluster",
      component: Cluster,
      props: true,
      meta: { title: 'Cluster Profile' },
      beforeEnter: authGuard
    },
    {
      path: "/industries",
      name: "industry",
      component: Industry,
      beforeEnter: authGuard
    },
    {
      path: "/panel",
      name: "panel",
      component: Panel,
      meta: { title: 'Panel Profile' },
      //props: true,
      beforeEnter: authGuard
    },
    {
      path: "/panels",
      name: "panels",
      component: Panels,
      meta: { title: 'Panels Directory' },
      beforeEnter: authGuard
    },
    {
      // Optional :threadId so a specific chat is restorable on reload / shareable
      // by URL. No id = a fresh new chat.
      path: "/tracey/:threadId?",
      name: "tracey-chat",
      component: TraceyChatPage,
      meta: { title: 'Tracey' },
      beforeEnter: authGuard
    },
    {
      path: "/usage",
      name: "tracey-usage",
      component: UsagePage,
      meta: { title: 'Usage' },
      beforeEnter: authGuard
    },
    {
      path: "/widgets/tracey-report",
      name: "tracey-report",
      component: TraceyResults,
      meta: { title: 'Tracey Report' },
      beforeEnter: authGuard
    }, 
    {
      path: "/open/:openboardId",
      name: "openboard",
      component: OpenBoard
    },
    {
      path: "/not_found",
      name: "notfound",
      component: NotFound
    },
    {
      path: "/unsubscribe",
      name: "unsubscribe",
      component: Unsubscribe,
      meta: { title: 'Unsubscribe' }
      // No beforeEnter: authGuard - public route for email unsubscribe links
    },
    {
      path: "/user",
      name: "user",
      component: User,
      meta: { title: 'My Profile' },
      beforeEnter: authGuard
    },
    {
      path: "/tender/:id",
      name: "tender",
      component: Tender,
      meta: { title: 'Notice' },
      beforeEnter: authGuard
    },
    
    {
      path: "/widgets/spending-tree",
      name: "spending-tree",
      component: SpendingTree,
      meta: { title: 'Government Spending Breakdown' },
      beforeEnter: authGuard
    },
    {
      path: "/widgets/quarterly-trends",
      name: "quarterly-trends",
      component: QuarterlyTrends,
      meta: { title: 'Quarterly Trends by FY' },
      beforeEnter: authGuard
    },
    {
      path: "/widgets/spending-scatter",
      name: "spending-scatter",
      component: SpendingScatter,
      beforeEnter: authGuard
    },
    {
      path: "/widgets/cumulative-comparison",
      name: "cumulative-comparison",
      component: SpendComparison,
      meta: { title: 'Participant Awards Over Time' },
      beforeEnter: authGuard
    },
    {
      path: "/widgets/leaderboard",
      name: "leaderboard",
      component: ResultsLeaderboard,
      meta: { title: 'Leaderboard' },
      beforeEnter: authGuard
    },
    
    {
      path: "/widgets/overall-spend",
      name: "overall-spend",
      component: SpendingPie,
      meta: { title: 'Market Share' },
      beforeEnter: authGuard
    },
    {
      path: "/widgets/report",
      name: "report",
      component: Report,
      meta: { title: 'Report' },
      beforeEnter: authGuard
    },
    {
      path: "/widgets/expiring-soon",
      name: "expiring-soon",
      component: ResultsExpiryCycle,
      meta: { title: 'Expiring soon' },
      beforeEnter: authGuard
    },
    {
      path: "/widgets/network",
      name: "network",
      component: NetworkView,
      meta: { title: 'Network' },
      beforeEnter: authGuard
    },
    ,
    {
      path: "/widgets/dashboard",
      name: "dashboard",
      component: ResultsDashboard,
      meta: { title: 'Dashboard'},
      beforeEnter: authGuard
    },
    {
      path: "/admin",
      name: "admin-portal",
      component: AdminPortal,
      meta: { title: 'Admin Portal' },
      beforeEnter: authGuard
    },
    {
      path: "/admin/storyboards",
      name: "admin-storyboards",
      component: StoryboardAdministration,
      meta: { title: 'Storyboard Management' },
      beforeEnter: authGuard
    },
    {
      path: "/admin/saved-searches",
      name: "admin-saved-searches",
      component: SavedSearchAdministration,
      meta: { title: 'Saved Search Management' },
      beforeEnter: authGuard
    },
    {
      path: "/admin/monitoring",
      name: "admin-monitoring",
      component: MonitoringAdministration,
      meta: { title: 'Monitoring' },
      beforeEnter: authGuard
    },
    {
      path: "/cluster-administration",
      name: "cluster-administration",
      component: ClusterAdministration,
      meta: { title: 'Cluster Administration' },
      beforeEnter: authGuard
    }

  ],
  /* scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }, */
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Explore Australian government tenders and contracts.';
  next();
})

export default router;
